import { extend } from 'vee-validate'
import { email, required, min, max, length, numeric, is } from 'vee-validate/dist/rules'

import {startOfDay, isBefore, parseISO} from 'date-fns'

extend('required', {
  ...required,
  message: 'validations.required'
})

extend('min', {
  ...min,
  message: (_, {length}) => {
    return {str: 'validations.min', values:{length: length}}
  }
})

extend('min_no_required', {
  validate: (value, length)=> {
    return !value || value.length >= length
  },
  message: (_, obj) => {
    return {str: 'validations.min', values:{length: obj[0]}}
  }
})

extend('max', {
  ...max,
  message: (_, {length}) => {
    return {str: 'validations.max', values:{length: length}}
  }
})

extend('length', {
  ...length,
  message: (_, {length}) => {
    return {str: 'validations.length', values:{length: length}}
  }
})

extend('numeric', {
  ...numeric,
  message: 'validations.numeric'
})

extend('pw_confirm', {
  validate(value, obj) {
    return value === obj[0]
  },
  message: 'validations.pw_confirm'
})
extend('password', {
  validate(value) {
    return /^[a-zA-Z0-9@%!?]+$/.test(value)
  },
  message: 'validations.password'
})

const pw_length = {
  validate(value, {min, max}) {
    return value.length >= min && value.length <= max
  },
  params: ['min', 'max']
}

const pw_alpha = {
  validate(value) {
    return /[a-z]/i.test(value)
  }
}

const pw_numeric = {
  validate(value) {
    return /[0-9]/.test(value)
  }
}

const pw_symbols = {
  validate(value) {
    return /[@%!?]/.test(value)
  }
}

const passwordValidations = {
  pw_length,
  pw_alpha,
  pw_numeric,
  pw_symbols
}


Object.entries(passwordValidations).forEach(([validationName, validationObj]) => {
  extend(validationName, validationObj)
})

extend('email', {
  ...email,
  message: 'validations.email'
})
extend('reg_email', {
  ...email,
  message: 'validations.reg_email'
})
extend('phone', {
  validate(value) {
    return /^[\+]?[0-9]*$/.test(value)
  },
  message: 'validations.phone'
})

extend('required_files', {
  validate(files) {
    return files?.filter(file => !(file.isUploading || file.hasError)).length > 0
  },
  message: 'validations.required'
})

extend('files_has_no_errors', {
  validate(files) {
    return files?.filter(file => file.hasError).length === 0
  },
  message: 'validations.required'
})

extend('isPastDate', {
  validate(value) {
    const today = new Date()
    return isBefore(parseISO(value), startOfDay(today))
  },
  message: 'validations.not_past_date'
})
